import React, { useState } from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
// Trigger deploy

export default function App() {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    location: ''
  });
  const [files, setFiles] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const [whoYouAreOpen, setWhoYouAreOpen] = useState(false);
  const [positionHighlightsOpen, setPositionHighlightsOpen] = useState(false);

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    if (selectedFiles.length > 0) {
      setFiles(selectedFiles);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (files.length === 0) {
      setSubmitStatus({ type: 'error', message: 'Please upload your portfolio' });
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus(null);

    const formDataToSend = new FormData();
    formDataToSend.append('fullName', formData.fullName);
    formDataToSend.append('email', formData.email);
    formDataToSend.append('phone', formData.phone);
    formDataToSend.append('location', formData.location);
    
    // Append all files
    files.forEach((file) => {
      formDataToSend.append('portfolio', file);
    });

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/submit-application`, {
        method: 'POST',
        body: formDataToSend
      });

      const data = await response.json();

      if (response.ok) {
        setSubmitStatus({ type: 'success', message: 'Application submitted successfully!' });
        // Reset form
        setFormData({
          fullName: '',
          email: '',
          phone: '',
          location: ''
        });
        setFiles([]);
        // Reset file input
        document.getElementById('portfolio-upload').value = '';
      } else {
        setSubmitStatus({ type: 'error', message: data.error || 'Failed to submit application' });
      }
    } catch (error) {
      setSubmitStatus({ type: 'error', message: 'Network error. Please try again.' });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="app-container">
      <Header />
      <main className="main-content">
        <div className="landing-header" style={{backgroundImage: 'url(/imgd.jpg)'}}>
          <div className="landing-header-content">
            <h1>Master Ceramist<br/>Opportunity</h1>
            <p className="tagline">Chesapeake, VA</p>
          </div>
        </div>

        <div className="who-you-are">
          <div className="who-you-are-inner">
            <div className="section-header" onClick={() => setWhoYouAreOpen(!whoYouAreOpen)}>
              <h2>Who You Are</h2>
              <span className={`toggle-icon ${whoYouAreOpen ? 'open' : ''}`}>▼</span>
            </div>
            {whoYouAreOpen && (
              <ul>
                <li>
                  <strong>Foundation Knowledge:</strong> Deep understanding of occlusion, tooth anatomy and morphology. Skilled in smile design and treatment planning.
                </li>
                <li>
                  <strong>Technical Skills:</strong> Advanced ceramic hand layering skills. Expert in glaze and stain monolithic makeup.
                </li>
                <li>
                  <strong>Versatility:</strong> A complete lab professional who bridges disciplines and is adaptable across all aspects of modern dental laboratory work.
                </li>
              </ul>
            )}
          </div>
        </div>

        <div className="position-highlights">
          <div className="position-highlights-inner">
            <div className="section-header" onClick={() => setPositionHighlightsOpen(!positionHighlightsOpen)}>
              <h2>Position Highlights</h2>
              <span className={`toggle-icon ${positionHighlightsOpen ? 'open' : ''}`}>▼</span>
            </div>
            {positionHighlightsOpen && (
              <ul>
                <li>Up to $150,000 base salary (based on experience)</li>
                <li>70% cosmetic cases</li>
                <li>Work with feldspathic veneers & complex aesthetics</li>
                <li>No production quotas - quality first</li>
                <li>Relocation assistance available</li>
                <li>Continuing education support & budget</li>
                <li>Path to AACD accreditation assistance</li>
                <li>Conference attendance opportunities</li>
              </ul>
            )}
          </div>
        </div>

        <div className="application-section" style={{backgroundImage: 'url(/img.png)'}}>
          <div className="application-form-section">
          <h2>Apply Now</h2>
          <form onSubmit={handleSubmit} className="application-form">
            <div className="form-group">
              <label htmlFor="fullName">Full Name *</label>
              <input
                type="text"
                id="fullName"
                name="fullName"
                value={formData.fullName}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">Email *</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="phone">Phone *</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="location">Location (City, State) *</label>
              <input
                type="text"
                id="location"
                name="location"
                placeholder="e.g., Richmond, VA"
                value={formData.location}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="form-group file-upload-group">
              <label htmlFor="portfolio-upload">
                Resume and portfolio with work examples required *
              </label>
              <input
                type="file"
                id="portfolio-upload"
                onChange={handleFileChange}
                accept=".pdf,.jpg,.jpeg,.png,.zip"
                multiple
                required
              />
              {files.length > 0 && (
                <div className="files-selected">
                  <p className="file-selected">Selected {files.length} file{files.length > 1 ? 's' : ''}:</p>
                  <ul className="file-list">
                    {files.map((file, index) => (
                      <li key={index}>{file.name}</li>
                    ))}
                  </ul>
                </div>
              )}
              <p className="file-hint">Accepted formats: PDF, JPEG, PNG, ZIP</p>
            </div>

            {submitStatus && (
              <div className={`status-message ${submitStatus.type}`}>
                {submitStatus.message}
              </div>
            )}

            <button 
              type="submit" 
              disabled={isSubmitting}
              className="submit-button"
            >
              <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
                {isSubmitting && (
                  <span style={{
                    display: 'inline-block',
                    width: '16px',
                    height: '16px',
                    border: '3px solid #fff',
                    borderTopColor: 'transparent',
                    borderRadius: '50%',
                    animation: 'spin 0.8s linear infinite'
                  }}></span>
                )}
                {isSubmitting ? 'Submitting...' : 'Submit Application'}
              </span>
            </button>
          </form>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}